<div class="min-h-[calc(100vh-10rem)] flex items-center justify-center py-12 px-4">
  <div class="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 shadow-lg">
    <div class="mb-6 text-center">
      <h1 class="text-2xl font-bold text-gray-900">Request password reset</h1>
      <p class="mt-1 text-sm text-gray-600">Enter the email address for your Scholaris account.</p>
    </div>

    <div class="mb-5 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-800">
      We will send a reset link to the email address below. The link is only sent if an active
      account exists in the system for that address.
    </div>

    <form [formGroup]="form" (ngSubmit)="requestResetLink()" class="space-y-4">
      <div>
        <label for="passwordResetEmail" class="block text-sm font-medium text-gray-700 mb-1">
          Email
        </label>
        <input
          id="passwordResetEmail"
          type="email"
          formControlName="email"
          placeholder="name@example.com"
          class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (submitted && form.controls.email.errors?.required) {
          <small class="text-sm text-yellow-700">Email is required.</small>
        }
        @if (submitted && form.controls.email.errors?.email) {
          <small class="text-sm text-yellow-700">Please enter a valid email address.</small>
        }
      </div>

      <button
        type="submit"
        class="w-full rounded-md bg-primary py-2.5 font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="loading"
      >
        {{ loading ? 'Requesting reset link...' : 'Request Reset Link' }}
      </button>
    </form>

    @if (successMessage) {
      <div
        class="mt-4 rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700"
      >
        {{ successMessage }}
      </div>
    }

    @if (errorMessage) {
      <div class="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="mt-5 text-center">
      <button
        type="button"
        class="text-sm font-semibold text-blue-600 hover:text-blue-700"
        (click)="goToLogin()"
      >
        Back to login
      </button>
    </div>
  </div>
</div>
